import { I18n } from "@lingui/core";
import { formatScore } from "./format";

const PERCENT_TAG_RE = /%([a-zA-Z0-9]+)%/g;
const BRACKET_TAG_RE = /\\?\[([a-zA-Z0-9]+)\\?]/g;

export function replaceTemplateTags(
  template: string,
  replacements: { [key: string]: string },
): string {
  const replacer = (match: string, tagName: string): string =>
    replacements[tagName] || match;

  return template
    .replace(PERCENT_TAG_RE, replacer)
    .replace(BRACKET_TAG_RE, replacer);
}

const getSevenDaysFromStarting = (startedAt: Date, i18n: I18n): string => {
  const date = new Date(startedAt);
  date.setDate(date.getDate() + 7);
  return i18n.date(date, { month: "long", day: "numeric" });
};

export const replaceResultScreenTemplateTags = (
  content: string,
  score: number,
  startedAt: Date,
  i18n: I18n,
) => {
  const formattedScore = formatScore(score, i18n);
  const sevenDaysFromStarting = getSevenDaysFromStarting(startedAt, i18n);

  return replaceTemplateTags(content, {
    score: formattedScore,
    CandidateScore: formattedScore,
    TestScore: formattedScore,
    "7DaysFromApplying": sevenDaysFromStarting,
  });
};
